var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1.5C23.2733 1.5 23.5067 1.6 23.7 1.8C23.9 1.99333 24 2.22667 24 2.5V21.5C24 21.7733 23.9 22.0067 23.7 22.2C23.5067 22.4 23.2733 22.5 23 22.5H7C6.72667 22.5 6.49333 22.4 6.3 22.2C6.1 22.0067 6 21.7733 6 21.5V18H1C0.726667 18 0.493333 17.9 0.3 17.7C0.1 17.5067 0 17.2733 0 17V7C0 6.72667 0.1 6.49333 0.3 6.3C0.486667 6.1 0.72 6 1 6H6V2.5C6 2.22667 6.1 1.99333 6.3 1.8C6.49333 1.6 6.72667 1.5 7 1.5H23ZM6 13.28L7.42 15.94H9.56L7.18 12.07L9.52 8.27H7.46L6.16 10.67L6.11 10.75L6.07 10.84L5.43 9.56L4.77 8.27H2.59L4.86 12.09L2.38 15.94H4.54L6 13.28ZM14.25 21V18H7.5V21H14.25ZM14.25 16.5V12.75H12V16.5H14.25ZM14.25 11.25V7.5H12V11.25H14.25ZM14.25 6V3H7.5V6H14.25ZM22.5 21V18H15.75V21H22.5ZM22.5 16.5V12.75H15.75V16.5H22.5ZM22.5 11.25V7.5H15.75V11.25H22.5ZM22.5 6V3H15.75V6H22.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.8111deb0caa702c04e35c8f5ba49bdab.svg";
export { ForwardRef as ReactComponent };